import { defineStore } from 'pinia'
import type {RouterOptions} from 'vue-router'

/**
 * 登录信息类型
 */
export interface LoginInfoType {
    userName: string
    passWord: string
    keepTime: number
  }
/**
 * 登录用户信息类型
 */
export interface UserInfoType {
  userID:number
  userName: string
  displayName: string
  headImgUrl: string
  keepTime: number
  expire:string
  mchID:number
}
/**
 * 登录状态信息类型
 */
interface UserState {
  loginInfo?: LoginInfoType
  tokenKey: string
  token: string
  roleRouters?: string[] | RouterOptions[]
  userInfo?: UserInfoType
}

export const useUserStore = defineStore('user', {
  state: (): UserState => {
    return {
        loginInfo: undefined,
      tokenKey: import.meta.env.VITE_AUTH_TOKEN_KEY,
      token: '',
      roleRouters: undefined,
      userInfo: undefined
    }
  },
  getters: {
    getTokenKey(): string {
      return this.tokenKey
    },
    getToken(): string {
      return this.token
    },
    getMchID(): number {
      if(this.userInfo==undefined){
          this.userInfo={
              userID:0,
              userName:'',
              displayName:'未登录',
              headImgUrl:'',
              keepTime:360,
              expire:'',
              mchID:0
          }
      }
      return this.userInfo.mchID
    },
    getUserInfo(): UserInfoType {
      if(this.userInfo==undefined){
          this.userInfo={
              userID:0,
              userName:'',
              displayName:'未登录',
              headImgUrl:'',
              keepTime:360,
              expire:'',
              mchID:0
          }
      }
      return this.userInfo
    },
    getRoleRouters(): string[] | RouterOptions[] | undefined {
      return this.roleRouters
    },
    getLoginInfo(): LoginInfoType | undefined {
        if(this.loginInfo==undefined){
            this.loginInfo={
                userName:'',
                passWord:'',
                keepTime:360
            }
        }
      return this.loginInfo
    }
  },
  actions: {
    setTokenKey(tokenKey: string) {
      this.tokenKey = tokenKey
    },
    setToken(token: string) {
      this.token = token
    },
    setUserInfo(userInfo?: UserInfoType) {
      this.userInfo = userInfo
    },
    setRoleRouters(roleRouters: string[] | RouterOptions[]) {
      this.roleRouters = roleRouters
    },
    reset() {
        this.token=''
        this.userInfo=undefined
        this.roleRouters =[]
    },
    setLoginInfo(loginInfo: LoginInfoType | undefined) {
      this.loginInfo = loginInfo
    }
  },
  persist: true
})

// export const useUserStoreWithOut = () => {
//   return useUserStore(store)
// }
